var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.624,
    height: 15.75,
    viewBox: "0 0 2.624 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10621",
    "data-name": "Path 10621",
    d: "M355.688,1222.41a1.321,1.321,0,1,0,.384-.92A1.3,1.3,0,0,0,355.688,1222.41Zm0,6.57a1.321,1.321,0,1,0,.384-.93A1.3,1.3,0,0,0,355.688,1228.98Zm0,6.56a1.32,1.32,0,0,0,.384.93,1.323,1.323,0,0,0,1.856,0,1.318,1.318,0,0,0,0-1.86,1.323,1.323,0,0,0-1.856,0A1.321,1.321,0,0,0,355.688,1235.54Z",
    transform: "translate(-355.688 -1221.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.e3b530b676b9cace311384bc7e83ae25.svg";
export { ForwardRef as ReactComponent };